// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-site-map-blocks .options-header {
  color: var(--fi-color-steel-grey);
  margin: 8px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
}
.edit-site-map-blocks .mat-mdc-checkbox .mdc-label {
  color: var(--fi-color-app-black);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  padding-left: 8px;
}`, "",{"version":3,"sources":["webpack://./Source/app/document/edit-item/sitemap/sitemap.component.scss"],"names":[],"mappings":"AACI;EACI,iCAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAAR;AAEI;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAAR","sourcesContent":[".edit-site-map-blocks {\r\n    .options-header {\r\n        color: var(--fi-color-steel-grey);\r\n        margin: 8px 0;\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        line-height: 20px;\r\n        letter-spacing: 0.1px;\r\n    }\r\n    .mat-mdc-checkbox .mdc-label {\r\n        color: var(--fi-color-app-black);\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        line-height: 20px;\r\n        letter-spacing: 0.25px;\r\n        padding-left: 8px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
